import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "EDIT_USER_VIEW", {
  TITLE: "Edit user",
  ERROR: "This email is already registered",
});
